"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
require("buffer");
var streams_1 = require("./streams");
var NONCE_LENGTH = 12;
var TAG_LENGTH = 16;
var KEY_LENGTH = 16;
var MODE_ENCRYPT = 'encrypt';
var MODE_DECRYPT = 'decrypt';
exports.ECE_RECORD_SIZE = 1024 * 64;
var encoder = new TextEncoder();
function generateSalt(len) {
    var randSalt = new Uint8Array(len);
    crypto.getRandomValues(randSalt);
    return randSalt.buffer;
}
var ECETransformer = (function () {
    function ECETransformer(mode, ikm, rs, salt) {
        this.mode = mode;
        this.prevChunk;
        this.seq = 0;
        this.firstchunk = true;
        this.rs = rs;
        this.ikm = ikm.buffer;
        this.salt = salt;
    }
    ECETransformer.prototype.generateKey = function () {
        return __awaiter(this, void 0, void 0, function () {
            var inputKey;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, crypto.subtle.importKey('raw', this.ikm, 'HKDF', false, ['deriveKey'])];
                    case 1:
                        inputKey = _a.sent();
                        return [2, crypto.subtle.deriveKey({
                                name: 'HKDF',
                                salt: this.salt,
                                info: encoder.encode('Content-Encoding: aes128gcm\0'),
                                hash: 'SHA-256'
                            }, inputKey, {
                                name: 'AES-GCM',
                                length: 128
                            }, true, ['encrypt', 'decrypt'])];
                }
            });
        });
    };
    ECETransformer.prototype.generateNonceBase = function () {
        return __awaiter(this, void 0, void 0, function () {
            var inputKey, base, _a, _b, _c;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0: return [4, crypto.subtle.importKey('raw', this.ikm, 'HKDF', false, ['deriveKey'])];
                    case 1:
                        inputKey = _d.sent();
                        _b = (_a = crypto.subtle).exportKey;
                        _c = ['raw'];
                        return [4, crypto.subtle.deriveKey({
                                name: 'HKDF',
                                salt: this.salt,
                                info: encoder.encode('Content-Encoding: nonce\0'),
                                hash: 'SHA-256'
                            }, inputKey, {
                                name: 'AES-GCM',
                                length: 128
                            }, true, ['encrypt', 'decrypt'])];
                    case 2: return [4, _b.apply(_a, _c.concat([_d.sent()]))];
                    case 3:
                        base = _d.sent();
                        return [2, Buffer.from(base.slice(0, NONCE_LENGTH))];
                }
            });
        });
    };
    ECETransformer.prototype.generateNonce = function (seq) {
        if (seq > 0xffffffff) {
            throw new Error('record sequence number exceeds limit');
        }
        var nonce = Buffer.from(this.nonceBase);
        var m = nonce.readUIntBE(nonce.length - 4, 4);
        var xor = (m ^ seq) >>> 0;
        nonce.writeUIntBE(xor, nonce.length - 4, 4);
        return nonce;
    };
    ECETransformer.prototype.pad = function (data, isLast) {
        var len = data.length;
        if (len + TAG_LENGTH >= this.rs) {
            throw new Error('data too large for record size');
        }
        if (isLast) {
            var padding = Buffer.alloc(1);
            padding.writeUInt8(2, 0);
            return Buffer.concat([data, padding]);
        }
        else {
            var padding = Buffer.alloc(this.rs - len - TAG_LENGTH);
            padding.fill(0);
            padding.writeUInt8(1, 0);
            return Buffer.concat([data, padding]);
        }
    };
    ECETransformer.prototype.unpad = function (data, isLast) {
        for (var i = data.length - 1; i >= 0; i--) {
            if (data[i]) {
                if (isLast) {
                    if (data[i] !== 2) {
                        throw new Error('delimiter of final record is not 2');
                    }
                }
                else {
                    if (data[i] !== 1) {
                        throw new Error('delimiter of not final record is not 1');
                    }
                }
                return data.slice(0, i);
            }
        }
        throw new Error('no delimiter found');
    };
    ECETransformer.prototype.createHeader = function () {
        if (this.salt === undefined)
            throw new Error('salt is undefined');
        var nums = Buffer.alloc(5);
        nums.writeUIntBE(this.rs, 0, 4);
        nums.writeUIntBE(0, 4, 1);
        return Buffer.concat([Buffer.from(this.salt), nums]);
    };
    ECETransformer.prototype.readHeader = function (buffer) {
        if (buffer.length < 21) {
            throw new Error('chunk too small for reading header');
        }
        var header = {};
        header.salt = buffer.buffer.slice(0, KEY_LENGTH);
        header.rs = buffer.readUIntBE(KEY_LENGTH, 4);
        var idlen = buffer.readUInt8(KEY_LENGTH + 4);
        header.length = idlen + KEY_LENGTH + 5;
        return header;
    };
    ECETransformer.prototype.encryptRecord = function (buffer, seq, isLast) {
        return __awaiter(this, void 0, void 0, function () {
            var nonce, encrypted;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        nonce = this.generateNonce(seq);
                        return [4, crypto.subtle.encrypt({ name: 'AES-GCM', iv: nonce }, this.key, this.pad(buffer, isLast))];
                    case 1:
                        encrypted = _a.sent();
                        return [2, Buffer.from(encrypted)];
                }
            });
        });
    };
    ECETransformer.prototype.decryptRecord = function (buffer, seq, isLast) {
        return __awaiter(this, void 0, void 0, function () {
            var nonce, data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        nonce = this.generateNonce(seq);
                        return [4, crypto.subtle.decrypt({
                                name: 'AES-GCM',
                                iv: nonce,
                                tagLength: 128
                            }, this.key, buffer)];
                    case 1:
                        data = _a.sent();
                        return [2, this.unpad(Buffer.from(data), isLast)];
                }
            });
        });
    };
    ECETransformer.prototype.start = function (controller) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (!(this.mode === MODE_ENCRYPT)) return [3, 3];
                        _a = this;
                        return [4, this.generateKey()];
                    case 1:
                        _a.key = _c.sent();
                        _b = this;
                        return [4, this.generateNonceBase()];
                    case 2:
                        _b.nonceBase = _c.sent();
                        controller.enqueue(this.createHeader());
                        return [3, 4];
                    case 3:
                        if (this.mode !== MODE_DECRYPT) {
                            throw new Error('mode must be either encrypt or decrypt');
                        }
                        _c.label = 4;
                    case 4: return [2];
                }
            });
        });
    };
    ECETransformer.prototype.transformPrevChunk = function (isLast, controller) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, _b, header, _c, _d, _e, _f;
            return __generator(this, function (_g) {
                switch (_g.label) {
                    case 0:
                        if (!(this.mode === MODE_ENCRYPT)) return [3, 2];
                        _b = (_a = controller).enqueue;
                        return [4, this.encryptRecord(this.prevChunk, this.seq, isLast)];
                    case 1:
                        _b.apply(_a, [_g.sent()]);
                        this.seq++;
                        return [3, 8];
                    case 2:
                        if (!(this.seq === 0)) return [3, 5];
                        header = this.readHeader(this.prevChunk);
                        this.salt = header.salt;
                        this.rs = header.rs;
                        _c = this;
                        return [4, this.generateKey()];
                    case 3:
                        _c.key = _g.sent();
                        _d = this;
                        return [4, this.generateNonceBase()];
                    case 4:
                        _d.nonceBase = _g.sent();
                        return [3, 7];
                    case 5:
                        _f = (_e = controller).enqueue;
                        return [4, this.decryptRecord(this.prevChunk, this.seq - 1, isLast)];
                    case 6:
                        _f.apply(_e, [_g.sent()]);
                        _g.label = 7;
                    case 7:
                        this.seq++;
                        _g.label = 8;
                    case 8: return [2];
                }
            });
        });
    };
    ECETransformer.prototype.transform = function (chunk, controller) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!!this.firstchunk) return [3, 2];
                        return [4, this.transformPrevChunk(false, controller)];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        this.firstchunk = false;
                        this.prevChunk = Buffer.from(chunk.buffer);
                        return [2];
                }
            });
        });
    };
    ECETransformer.prototype.flush = function (controller) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.prevChunk) return [3, 2];
                        return [4, this.transformPrevChunk(true, controller)];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [2];
                }
            });
        });
    };
    return ECETransformer;
}());
var StreamSlicer = (function () {
    function StreamSlicer(rs, mode) {
        this.mode = mode;
        this.rs = rs;
        this.chunkSize = mode === MODE_ENCRYPT ? rs - 17 : 21;
        this.partialChunk = new Uint8Array(this.chunkSize);
        this.offset = 0;
    }
    StreamSlicer.prototype.send = function (buf, controller) {
        controller.enqueue(buf);
        if (this.chunkSize === 21 && this.mode === MODE_DECRYPT) {
            this.chunkSize = this.rs;
        }
        this.partialChunk = new Uint8Array(this.chunkSize);
        this.offset = 0;
    };
    StreamSlicer.prototype.transform = function (chunk, controller) {
        var i = 0;
        if (this.offset > 0) {
            var len = Math.min(chunk.byteLength, this.chunkSize - this.offset);
            this.partialChunk.set(chunk.slice(0, len), this.offset);
            this.offset += len;
            i += len;
            if (this.offset === this.chunkSize) {
                this.send(this.partialChunk, controller);
            }
        }
        while (i < chunk.byteLength) {
            var remainingBytes = chunk.byteLength - i;
            if (remainingBytes >= this.chunkSize) {
                var record = chunk.slice(i, i + this.chunkSize);
                i += this.chunkSize;
                this.send(record, controller);
            }
            else {
                var end = chunk.slice(i, i + remainingBytes);
                i += end.byteLength;
                this.partialChunk.set(end);
                this.offset = end.byteLength;
            }
        }
    };
    StreamSlicer.prototype.flush = function (controller) {
        if (this.offset > 0) {
            controller.enqueue(this.partialChunk.slice(0, this.offset));
        }
    };
    return StreamSlicer;
}());
function encryptStream(input, key, rs, salt) {
    if (rs === void 0) { rs = exports.ECE_RECORD_SIZE; }
    if (salt === void 0) { salt = generateSalt(KEY_LENGTH); }
    var mode = 'encrypt';
    var inputStream = streams_1.transformStream(input, new StreamSlicer(rs, mode));
    return streams_1.transformStream(inputStream, new ECETransformer(mode, key, rs, salt));
}
exports.encryptStream = encryptStream;
function decryptStream(input, key, rs) {
    if (rs === void 0) { rs = exports.ECE_RECORD_SIZE; }
    var mode = 'decrypt';
    var inputStream = streams_1.transformStream(input, new StreamSlicer(rs, mode));
    return streams_1.transformStream(inputStream, new ECETransformer(mode, key, rs));
}
exports.decryptStream = decryptStream;
//# sourceMappingURL=ece.js.map